import React from "react";

import footerBg from "../assets/bg.webp";
import logo from "../assets/footer_logo.webp";
import iconFacebook from "../assets/fb.svg";
import iconInstagram from "../assets/instagram.svg";
import iconLinkedIn from "../assets/linkedin.svg";

const YoutubeIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="YouTube"
  >
    <rect
      x="0.4"
      y="0.4"
      width="36.8699"
      height="36.8699"
      rx="18.435"
      stroke="white"
      strokeWidth="0.8"
    />
    <path
      d="M27.62 14.37C27.41 13.59 26.8 12.98 26.02 12.77C24.61 12.39 18.93 12.39 18.93 12.39C18.93 12.39 13.25 12.39 11.84 12.77C11.06 12.98 10.45 13.59 10.24 14.37C9.86 15.78 9.86 18.73 9.86 18.73C9.86 18.73 9.86 21.68 10.24 23.09C10.45 23.87 11.06 24.48 11.84 24.69C13.25 25.07 18.93 25.07 18.93 25.07C18.93 25.07 24.61 25.07 26.02 24.69C26.8 24.48 27.41 23.87 27.62 23.09C28 21.68 28 18.73 28 18.73C28 18.73 28 15.78 27.62 14.37ZM17.08 21.41V16.05L21.79 18.73L17.08 21.41Z"
      fill="white"
    />
  </svg>
);

const TwitterIcon = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Twitter"
  >
    <rect
      x="0.4"
      y="0.4"
      width="36.8699"
      height="36.8699"
      rx="18.435"
      stroke="white"
      strokeWidth="0.8"
    />
    <path
      d="M22.87 11.25H25.55L19.69 17.95L26.58 27.06H21.18L16.95 21.53L12.11 27.06H9.43L15.7 19.89L9.09 11.25H14.63L18.45 16.3L22.87 11.25ZM21.93 25.46H23.41L13.83 12.77H12.24L21.93 25.46Z"
      fill="white"
    />
  </svg>
);

const SOCIAL_LINKS = [
  {
    href: "https://in.linkedin.com/company/hysea",
    title: "LinkedIn - @hysea",
    alt: "li",
    icon: iconLinkedIn,
  },
  {
    href: "https://www.facebook.com/Official.HYSEA/",
    title: "Facebook - Official.HYSEA",
    alt: "fb",
    icon: iconFacebook,
  },
  {
    href: "https://www.instagram.com/official.hysea/",
    title: "Instagram - @official.hysea",
    alt: "ig",
    icon: iconInstagram,
  },
  {
    href: "https://www.youtube.com/c/hyderabadsoftwareenterprisesassociation",
    title: "YouTube - @HyseaIndia",
    Component: YoutubeIcon,
  },
  {
    href: "https://x.com/HYSEA1991",
    title: "Twitter - HYSEA1991",
    Component: TwitterIcon,
  },
];

const Footer = () => {
  return (
    <footer
      className="w-full bg-cover bg-center bg-no-repeat py-3 md:py-4"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="mx-auto max-w-9xl px-4 sm:px-6 md:px-12">
        <div className="flex items-center justify-between">
          <img
            src={logo}
            alt="HYSEA"
            className="h-10 md:h-14 object-contain"
          />

          <div className="flex flex-col items-end gap-2">
            <div className="flex items-center gap-3 md:gap-4">
              {SOCIAL_LINKS.map(({ href, title, alt, icon, Component }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={title}
                >
                  {Component ? (
                    <Component className="w-6 h-6" />
                  ) : (
                    <img src={icon} className="w-6 h-6" alt={alt} />
                  )}
                </a>
              ))}
            </div>

            <a
              href="https://www.hysea.in"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs md:text-sm text-white/90 hover:text-white"
            >
              www.hysea.in
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
